var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroHeaderBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1673.6 822.01",
    style: {
      enableBackground: "new 0 0 1673.6 822.01"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M621.59,298.97c-2.98-49.67-42.72-89.43-92.39-92.4C532.18,256.24,571.92,295.99,621.59,298.97z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517.24,206.57c-2.98,49.67-42.72,89.43-92.39,92.4C427.83,249.3,467.57,209.55,517.24,206.57z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.85,310.94c2.98,49.67,42.72,89.43,92.39,92.41C514.26,353.67,474.52,313.92,424.85,310.94z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M529.21,403.34c2.98-49.67,42.72-89.43,92.39-92.41C618.62,360.61,578.88,400.36,529.21,403.34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M836.82,298.97c-2.98-49.67-42.72-89.43-92.39-92.4C747.41,256.24,787.15,295.99,836.82,298.97z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M732.47,206.57c-2.98,49.67-42.72,89.43-92.39,92.4C643.06,249.3,682.8,209.55,732.47,206.57z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640.08,310.94c2.98,49.67,42.72,89.43,92.39,92.41C729.49,353.67,689.75,313.92,640.08,310.94z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M744.43,403.34c2.98-49.67,42.72-89.43,92.39-92.41C833.84,360.61,794.1,400.36,744.43,403.34z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.15,298.97c2.98-49.67,42.72-89.43,92.39-92.4C298.56,256.24,258.82,295.99,209.15,298.97z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.5,206.57c2.98,49.67,42.72,89.43,92.39,92.4C402.91,249.3,363.17,209.55,313.5,206.57z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.88,310.94c-2.98,49.67-42.72,89.43-92.39,92.41C316.47,353.67,356.21,313.92,405.88,310.94z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.53,403.34c-2.98-49.67-42.72-89.43-92.39-92.41C212.12,360.61,251.86,400.36,301.53,403.34z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M621.59,507.71c-2.98-49.67-42.72-89.42-92.39-92.4C532.18,464.98,571.92,504.73,621.59,507.71z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517.24,415.31c-2.98,49.67-42.72,89.42-92.39,92.4C427.83,458.04,467.57,418.29,517.24,415.31z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.85,519.68c2.98,49.67,42.72,89.43,92.39,92.41C514.26,562.41,474.52,522.66,424.85,519.68z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M529.21,612.08c2.98-49.67,42.72-89.43,92.39-92.41C618.62,569.35,578.88,609.11,529.21,612.08z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M836.82,507.71c-2.98-49.67-42.72-89.42-92.39-92.4C747.41,464.98,787.15,504.73,836.82,507.71z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M732.47,415.31c-2.98,49.67-42.72,89.42-92.39,92.4C643.06,458.04,682.8,418.29,732.47,415.31z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640.08,519.68c2.98,49.67,42.72,89.43,92.39,92.41C729.49,562.41,689.75,522.66,640.08,519.68z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M744.43,612.08c2.98-49.67,42.72-89.43,92.39-92.41C833.84,569.35,794.1,609.11,744.43,612.08z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.15,507.71c2.98-49.67,42.72-89.42,92.39-92.4C298.56,464.98,258.82,504.73,209.15,507.71z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.5,415.31c2.98,49.67,42.72,89.42,92.39,92.4C402.91,458.04,363.17,418.29,313.5,415.31z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.88,519.68c-2.98,49.67-42.72,89.43-92.39,92.41C316.47,562.41,356.21,522.66,405.88,519.68z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.53,612.08c-2.98-49.67-42.72-89.43-92.39-92.41C212.12,569.35,251.86,609.11,301.53,612.08z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M621.59,92.4C618.62,42.73,578.88,2.98,529.21,0C532.18,49.67,571.92,89.43,621.59,92.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517.24,0c-2.98,49.67-42.72,89.43-92.39,92.4C427.83,42.73,467.57,2.98,517.24,0z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.85,104.37c2.98,49.67,42.72,89.43,92.39,92.4C514.26,147.1,474.52,107.35,424.85,104.37z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M529.21,196.78c2.98-49.67,42.72-89.43,92.39-92.4C618.62,154.04,578.88,193.8,529.21,196.78z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M836.82,92.4C833.84,42.73,794.1,2.98,744.43,0C747.41,49.67,787.15,89.43,836.82,92.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M732.47,0c-2.98,49.67-42.72,89.43-92.39,92.4C643.06,42.73,682.8,2.98,732.47,0z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640.08,104.37c2.98,49.67,42.72,89.43,92.39,92.4C729.49,147.1,689.75,107.35,640.08,104.37z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M744.43,196.78c2.98-49.67,42.72-89.43,92.39-92.4C833.84,154.04,794.1,193.8,744.43,196.78z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1044.81,298.97c-2.98-49.67-42.72-89.43-92.39-92.4C955.4,256.24,995.14,295.99,1044.81,298.97z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M940.45,206.57c-2.98,49.67-42.72,89.43-92.39,92.4C851.04,249.3,890.78,209.55,940.45,206.57z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M848.06,310.94c2.98,49.67,42.72,89.43,92.39,92.41C937.47,353.67,897.73,313.92,848.06,310.94z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M952.42,403.34c2.98-49.67,42.72-89.43,92.39-92.41C1041.83,360.61,1002.09,400.36,952.42,403.34z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1044.81,507.71c-2.98-49.67-42.72-89.42-92.39-92.4C955.4,464.98,995.14,504.73,1044.81,507.71z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M940.45,415.31c-2.98,49.67-42.72,89.42-92.39,92.4C851.04,458.04,890.78,418.29,940.45,415.31z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M848.06,519.68c2.98,49.67,42.72,89.43,92.39,92.41C937.47,562.41,897.73,522.66,848.06,519.68z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M952.42,612.08c2.98-49.67,42.72-89.43,92.39-92.41C1041.83,569.35,1002.09,609.11,952.42,612.08z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1044.81,92.4c-2.98-49.67-42.72-89.43-92.39-92.4C955.4,49.67,995.14,89.43,1044.81,92.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M940.45,0c-2.98,49.67-42.72,89.43-92.39,92.4C851.04,42.73,890.78,2.98,940.45,0z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M848.06,104.37c2.98,49.67,42.72,89.43,92.39,92.4C937.47,147.1,897.73,107.35,848.06,104.37z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M952.42,196.78c2.98-49.67,42.72-89.43,92.39-92.4C1041.83,154.04,1002.09,193.8,952.42,196.78z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.38,298.97c-2.98-49.67-42.72-89.43-92.39-92.4C108.97,256.24,148.71,295.99,198.38,298.97z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.03,206.57c-2.98,49.67-42.72,89.43-92.39,92.4C4.62,249.3,44.36,209.55,94.03,206.57z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.64,310.94c2.98,49.67,42.72,89.43,92.39,92.41C91.05,353.67,51.31,313.92,1.64,310.94z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,403.34c2.98-49.67,42.72-89.43,92.39-92.41C195.41,360.61,155.66,400.36,106,403.34z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.38,507.71c-2.98-49.67-42.72-89.42-92.39-92.4C108.97,464.98,148.71,504.73,198.38,507.71z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.03,415.31c-2.98,49.67-42.72,89.42-92.39,92.4C4.62,458.04,44.36,418.29,94.03,415.31z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.64,519.68c2.98,49.67,42.72,89.43,92.39,92.41C91.05,562.41,51.31,522.66,1.64,519.68z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,612.08c2.98-49.67,42.72-89.43,92.39-92.41C195.41,569.35,155.66,609.11,106,612.08z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.38,92.4C195.41,42.73,155.66,2.98,106,0C108.97,49.67,148.71,89.43,198.38,92.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.03,0C91.05,49.67,51.3,89.43,1.64,92.4C4.62,42.73,44.36,2.98,94.03,0z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.64,104.37c2.98,49.67,42.72,89.43,92.39,92.4C91.05,147.1,51.31,107.35,1.64,104.37z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,196.78c2.98-49.67,42.72-89.43,92.39-92.4C195.41,154.04,155.66,193.8,106,196.78z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.15,92.4c2.97-49.68,42.72-89.43,92.38-92.4C298.55,49.67,258.81,89.43,209.15,92.4L209.15,92.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.5,0c2.98,49.67,42.72,89.43,92.39,92.4C402.91,42.73,363.16,2.98,313.5,0z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.88,104.37c-2.98,49.67-42.72,89.43-92.39,92.4C316.47,147.1,356.21,107.35,405.88,104.37z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.53,196.78c-2.98-49.67-42.72-89.43-92.39-92.4C212.12,154.04,251.86,193.8,301.53,196.78z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1252.88,298.97c-2.98-49.67-42.72-89.43-92.39-92.4C1163.47,256.24,1203.21,295.99,1252.88,298.97z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1148.52,206.57c-2.98,49.67-42.72,89.43-92.39,92.4C1059.11,249.3,1098.85,209.55,1148.52,206.57z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1056.13,310.94c2.98,49.67,42.72,89.42,92.39,92.4C1145.54,353.67,1105.8,313.92,1056.13,310.94z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1160.49,403.34c2.98-49.67,42.72-89.42,92.39-92.4C1249.9,360.61,1210.16,400.36,1160.49,403.34z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1252.88,507.71c-2.98-49.67-42.72-89.42-92.39-92.4C1163.47,464.98,1203.21,504.73,1252.88,507.71z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1148.52,415.31c-2.98,49.67-42.72,89.42-92.39,92.4C1059.11,458.04,1098.85,418.29,1148.52,415.31z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1056.13,519.68c2.98,49.67,42.72,89.43,92.39,92.41C1145.54,562.41,1105.8,522.66,1056.13,519.68z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1160.49,612.08c2.98-49.67,42.72-89.43,92.39-92.41C1249.9,569.35,1210.16,609.11,1160.49,612.08z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1252.88,92.4c-2.98-49.67-42.72-89.43-92.39-92.4C1163.47,49.67,1203.21,89.43,1252.88,92.4z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1148.52,0c-2.98,49.67-42.72,89.43-92.39,92.4C1059.11,42.73,1098.85,2.98,1148.52,0z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1056.13,104.37c2.98,49.67,42.72,89.43,92.39,92.4C1145.54,147.1,1105.8,107.35,1056.13,104.37z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1160.49,196.78c2.98-49.67,42.72-89.43,92.39-92.4C1249.9,154.04,1210.16,193.8,1160.49,196.78z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M619.95,717.64c-2.98-49.67-42.72-89.42-92.39-92.4C530.54,674.91,570.28,714.66,619.95,717.64z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.6,625.24c-2.98,49.67-42.72,89.42-92.39,92.4C426.19,667.97,465.93,628.22,515.6,625.24z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.21,729.61c2.98,49.67,42.72,89.42,92.39,92.4C512.62,772.34,472.88,732.59,423.21,729.61z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M527.56,822.01c2.98-49.67,42.72-89.43,92.39-92.4C616.97,779.28,577.23,819.04,527.56,822.01z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M835.18,717.64c-2.98-49.67-42.72-89.42-92.39-92.4C745.77,674.91,785.51,714.66,835.18,717.64z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730.83,625.24c-2.98,49.67-42.72,89.42-92.39,92.4C641.42,667.97,681.16,628.22,730.83,625.24z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M638.44,729.61c2.98,49.67,42.72,89.42,92.39,92.4C727.85,772.34,688.11,732.59,638.44,729.61z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M742.79,822.01c2.98-49.67,42.72-89.43,92.39-92.4C832.2,779.28,792.46,819.04,742.79,822.01z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.5,717.64c2.98-49.67,42.72-89.42,92.39-92.4C296.91,674.91,257.17,714.66,207.5,717.64z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.86,625.24c2.98,49.67,42.72,89.42,92.39,92.4C401.27,667.97,361.53,628.22,311.86,625.24z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.24,729.61c-2.98,49.67-42.72,89.43-92.39,92.41C314.83,772.34,354.57,732.59,404.24,729.61z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.89,822.01c-2.98-49.67-42.72-89.43-92.39-92.41C210.48,779.28,250.22,819.04,299.89,822.01z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1043.16,717.64c-2.98-49.67-42.72-89.42-92.39-92.4C953.75,674.91,993.49,714.66,1043.16,717.64z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M938.81,625.24c-2.98,49.67-42.72,89.42-92.39,92.4C849.4,667.97,889.14,628.22,938.81,625.24z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M846.42,729.61c2.98,49.67,42.72,89.42,92.39,92.4C935.83,772.34,896.09,732.59,846.42,729.61z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M950.77,822.01c2.98-49.67,42.72-89.43,92.39-92.4C1040.18,779.28,1000.44,819.04,950.77,822.01z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.74,717.64c-2.98-49.67-42.72-89.42-92.39-92.4C107.33,674.91,147.07,714.66,196.74,717.64z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.39,625.24c-2.98,49.67-42.72,89.42-92.39,92.4C2.98,667.97,42.72,628.22,92.39,625.24z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,729.61c2.98,49.67,42.72,89.42,92.39,92.4C89.41,772.34,49.67,732.59,0,729.61z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.35,822.01c2.98-49.67,42.72-89.43,92.39-92.4C193.76,779.28,154.02,819.04,104.35,822.01z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1251.23,717.64c-2.98-49.67-42.72-89.42-92.39-92.4C1161.82,674.91,1201.56,714.66,1251.23,717.64z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1146.88,625.24c-2.98,49.67-42.72,89.42-92.39,92.4C1057.47,667.97,1097.21,628.22,1146.88,625.24z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1054.49,729.61c2.98,49.67,42.72,89.42,92.39,92.4C1143.9,772.34,1104.16,732.59,1054.49,729.61z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1158.84,822.01c2.98-49.67,42.72-89.43,92.39-92.4C1248.25,779.28,1208.51,819.04,1158.84,822.01z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1463.24,298.97c-2.98-49.67-42.72-89.43-92.39-92.4C1373.83,256.24,1413.57,295.99,1463.24,298.97z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1358.88,206.57c-2.98,49.67-42.72,89.43-92.39,92.4C1269.47,249.3,1309.21,209.55,1358.88,206.57z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1266.49,310.94c2.98,49.67,42.72,89.42,92.39,92.4C1355.9,353.67,1316.16,313.92,1266.49,310.94z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1370.85,403.34c2.98-49.67,42.72-89.42,92.39-92.4C1460.26,360.61,1420.52,400.36,1370.85,403.34z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1463.24,507.71c-2.98-49.67-42.72-89.42-92.39-92.4C1373.83,464.98,1413.57,504.73,1463.24,507.71z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1358.88,415.31c-2.98,49.67-42.72,89.42-92.39,92.4C1269.47,458.04,1309.21,418.29,1358.88,415.31z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1266.49,519.68c2.98,49.67,42.72,89.43,92.39,92.41C1355.9,562.41,1316.16,522.66,1266.49,519.68z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1370.85,612.08c2.98-49.67,42.72-89.43,92.39-92.41C1460.26,569.35,1420.52,609.11,1370.85,612.08z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1463.24,92.4c-2.98-49.67-42.72-89.43-92.39-92.4C1373.83,49.67,1413.57,89.43,1463.24,92.4z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1358.88,0c-2.98,49.67-42.72,89.43-92.39,92.4C1269.47,42.73,1309.21,2.98,1358.88,0z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1266.49,104.37c2.98,49.67,42.72,89.43,92.39,92.4C1355.9,147.1,1316.16,107.35,1266.49,104.37z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1370.85,196.78c2.98-49.67,42.72-89.43,92.39-92.4C1460.26,154.04,1420.52,193.8,1370.85,196.78z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1461.59,717.64c-2.98-49.67-42.72-89.42-92.39-92.4C1372.18,674.91,1411.92,714.66,1461.59,717.64z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1357.24,625.24c-2.98,49.67-42.72,89.42-92.39,92.4C1267.83,667.97,1307.57,628.22,1357.24,625.24z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1264.85,729.61c2.98,49.67,42.72,89.42,92.39,92.4C1354.26,772.34,1314.52,732.59,1264.85,729.61z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1369.2,822.01c2.98-49.67,42.72-89.43,92.39-92.4C1458.61,779.28,1418.87,819.04,1369.2,822.01z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1673.6,298.97c-2.98-49.67-42.72-89.43-92.39-92.4C1584.19,256.24,1623.93,295.99,1673.6,298.97z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1569.24,206.57c-2.98,49.67-42.72,89.43-92.39,92.4C1479.83,249.3,1519.57,209.55,1569.24,206.57z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1476.85,310.94c2.98,49.67,42.72,89.42,92.39,92.4C1566.26,353.67,1526.52,313.92,1476.85,310.94z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1581.21,403.34c2.98-49.67,42.72-89.42,92.39-92.4C1670.62,360.61,1630.88,400.36,1581.21,403.34z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1673.6,507.71c-2.98-49.67-42.72-89.42-92.39-92.4C1584.19,464.98,1623.93,504.73,1673.6,507.71z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1569.24,415.31c-2.98,49.67-42.72,89.42-92.39,92.4C1479.83,458.04,1519.57,418.29,1569.24,415.31z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1476.85,519.68c2.98,49.67,42.72,89.43,92.39,92.41C1566.26,562.41,1526.52,522.66,1476.85,519.68z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1581.21,612.08c2.98-49.67,42.72-89.43,92.39-92.41C1670.62,569.35,1630.88,609.11,1581.21,612.08z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1673.6,92.4c-2.98-49.67-42.72-89.43-92.39-92.4C1584.19,49.67,1623.93,89.43,1673.6,92.4z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1569.24,0c-2.98,49.67-42.72,89.43-92.39,92.4C1479.83,42.73,1519.57,2.98,1569.24,0z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1476.85,104.37c2.98,49.67,42.72,89.43,92.39,92.4C1566.26,147.1,1526.52,107.35,1476.85,104.37z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1581.21,196.78c2.98-49.67,42.72-89.43,92.39-92.4C1670.62,154.04,1630.88,193.8,1581.21,196.78z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1671.95,717.64c-2.98-49.67-42.72-89.42-92.39-92.4C1582.54,674.91,1622.28,714.66,1671.95,717.64z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1567.6,625.24c-2.98,49.67-42.72,89.42-92.39,92.4C1478.19,667.97,1517.93,628.22,1567.6,625.24z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1475.21,729.61c2.98,49.67,42.72,89.42,92.39,92.4C1564.62,772.34,1524.88,732.59,1475.21,729.61z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1579.56,822.01c2.98-49.67,42.72-89.43,92.39-92.4C1668.97,779.28,1629.23,819.04,1579.56,822.01z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroHeaderBg);
export default __webpack_public_path__ + "static/media/HeroHeaderBG.3877bd2b5cd95c7b831514cfaf806de8.svg";
export { ForwardRef as ReactComponent };